// import React, { useState, useEffect } from 'react';
// import dubaiSouth1 from '../../images/dubai_south/1.jpeg';
// import dubaiSouth2 from '../../images/dubai_south/2.jpeg';
// import dubaiSouth3 from '../../images/dubai_south/3.jpeg';
// import dubaiSouth4 from '../../images/dubai_south/4.jpeg';
// import dubaiSouth5 from '../../images/dubai_south/5.jpeg';
// import dubaiSouth6 from '../../images/dubai_south/6.jpeg';
// import dubaiSouth7 from '../../images/dubai_south/7.jpeg';
// import './DubaiSouthCarousel.css';

// const DubaiSouthCarousel = () => {
//     const [currentImageIndex, setCurrentImageIndex] = useState(0);

//     const dubaiSouthImages = [
//         dubaiSouth1,
//         dubaiSouth2,
//         dubaiSouth3,
//         dubaiSouth4,
//         dubaiSouth5,
//         dubaiSouth6,
//         dubaiSouth7
//     ];

//     useEffect(() => {
//         const interval = setInterval(() => {
//             setCurrentImageIndex(prevIndex =>
//                 prevIndex === dubaiSouthImages.length - 1 ? 0 : prevIndex + 1
//             );
//         }, 3000); // Change image every 3 seconds

//         return () => clearInterval(interval);
//     }, [dubaiSouthImages.length]);

//     return (
//         <div className="dubai-south-carousel">
//             <div className="carousel-container">
//                 <div className="image-wrapper">
//                     <img
//                         src={dubaiSouthImages[currentImageIndex]}
//                         alt={`Dubai South Project - ${currentImageIndex + 1}`}
//                         className="carousel-image"
//                     />
//                     <div className="image-overlay">
//                         <div className="overlay-content">
//                             <h3>Dubai South MAAK Residence</h3>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="carousel-indicators">
//                     {dubaiSouthImages.map((_, index) => (
//                         <span
//                             key={index}
//                             className={`carousel-dot ${currentImageIndex === index ? 'active' : ''}`}
//                             onClick={() => setCurrentImageIndex(index)}
//                         ></span>
//                     ))}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default DubaiSouthCarousel; 





















import React, { useState, useEffect } from "react";
import "./DubaiSouthCarousel.css";

const DubaiSouthCarousel = ({ images = [], overlayContent }) => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        if (!images.length) return;

        const interval = setInterval(() => {
            setCurrentImageIndex((prevIndex) =>
                prevIndex === images.length - 1 ? 0 : prevIndex + 1
            );
        }, 3000);

        return () => clearInterval(interval);
    }, [images]);

    if (!images.length) return null;

    return (
        <div className="dubai-south-carousel">
            <div className="carousel-container">
                <div className="image-wrapper">
                    <img
                        src={images[currentImageIndex]?.image}
                        alt={`About Image ${currentImageIndex + 1}`}
                        className="carousel-image"
                    />

                    <div className="image-overlay">
                        <div className="overlay-content">
                            <h3>{overlayContent}</h3>
                        </div>
                    </div>
                </div>

                <div className="carousel-indicators">
                    {images.map((img, index) => (
                        <span
                            key={index}
                            className={`carousel-dot ${
                                currentImageIndex === index ? "active" : ""
                            }`}
                            onClick={() => setCurrentImageIndex(index)}
                        ></span>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default DubaiSouthCarousel;